<template>
  <nav class="nav">
    <ul class="list" :class="{ 'list--active': currentPage }">
      <li v-for="(section, idx) in $store.getters.sections" :key="section.name">
        <button
          class="button"
          :class="{ 'button--active': section.isActiveSection }"
          @click="click(idx, $event)"
          v-text="section.navTitle"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 0
    }
  },
  methods: {
    click(idx, e) {
      e.target.blur()
      this.$emit('click', idx)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  @include hide-down(lg);
  position: fixed;
  bottom: 60px;
  width: 100%;
  z-index: z(sections-bottom-nav);
}

.list {
  display: flex;
  justify-content: center;

  pointer-events: none;

  &--active {
    pointer-events: auto;
  }
}

.button {
  @include reset-button;
  color: $main-color;
  font-family: $bold-font;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  padding: 30px 8px;

  transition: transform 0.4s, color 0.4s;

  &--active,
  &:hover,
  &:focus {
    color: $text-color;
    transform: translateY(-12%);
  }

  @include media-down(xl) {
    font-size: 12px;
  }
}
</style>
